(() => {
  const copy = document.getElementById('MfxZoomCopy');
  const root = document.getElementById('MainContent');
  if (!copy || !root) return;
  const selector = 'media-gallery .product-media-container--image .product-media';
  let active = null;
  let gesture = null;
  let suppressClick = false;

  const setZoom = (media, zoomed) => {
    media.setAttribute('aria-pressed', String(zoomed));
    media.setAttribute('aria-label', zoomed ? copy.dataset.reset : copy.dataset.zoom);
    if (!zoomed) {
      media.style.removeProperty('--mfx-zoom-x');
      media.style.removeProperty('--mfx-zoom-y');
    }
  };
  const reset = () => {
    if (active) setZoom(active, false);
    active = null;
  };
  const position = (media, event) => {
    const frame = media.getBoundingClientRect();
    if (!frame.width || !frame.height) return;
    const x = Math.max(0, Math.min(100, (event.clientX - frame.left) / frame.width * 100));
    const y = Math.max(0, Math.min(100, (event.clientY - frame.top) / frame.height * 100));
    media.style.setProperty('--mfx-zoom-x', `${x}%`);
    media.style.setProperty('--mfx-zoom-y', `${y}%`);
  };
  const toggle = (media, event) => {
    if (media === active) { reset(); return; }
    reset();
    active = media;
    const image = media.querySelector('.product-media__image');
    const resolution = image.getAttribute('data_max_resolution');
    if (resolution) {
      image.removeAttribute('srcset');
      image.src = resolution;
    }
    setZoom(media, true);
    if (event && event.detail !== 0) position(media, event);
  };
  const initialize = () => {
    root.querySelectorAll(selector).forEach(media => {
      if (media.closest('zoom-dialog') || !media.querySelector('.product-media__image')) return;
      media.tabIndex = media.closest('[aria-hidden="true"]') ? -1 : 0;
      if (media.classList.contains('mfx-inline-zoom')) return;
      media.classList.add('mfx-inline-zoom');
      media.setAttribute('role', 'button');
      setZoom(media, false);
      media.closest('[on\\:click]')?.removeAttribute('on:click');
      media.addEventListener('pointerdown', event => {
        suppressClick = false;
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, moved: false };
        if (active === media && event.pointerType !== 'mouse') media.setPointerCapture(event.pointerId);
      });
      media.addEventListener('pointermove', event => {
        if (gesture?.id === event.pointerId && Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 8) {
          gesture.moved = true;
        }
        if (active === media) position(media, event);
      });
      media.addEventListener('pointerup', () => {
        suppressClick = Boolean(gesture?.moved);
        gesture = null;
      });
      media.addEventListener('pointercancel', () => { gesture = null; suppressClick = true; });
    });
    if (active && (!active.isConnected || active.closest('[aria-hidden="true"]'))) reset();
  };
  root.addEventListener('click', event => {
    const media = event.target.closest('.mfx-inline-zoom');
    if (!media) {
      if (event.target.closest('media-gallery :is(slideshow-controls, slideshow-arrows)')) reset();
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!suppressClick) toggle(media, event);
    suppressClick = false;
  }, true);
  root.addEventListener('keydown', event => {
    if (event.key === 'Escape') { reset(); return; }
    const media = event.target.closest('.mfx-inline-zoom');
    if (!media || !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    toggle(media);
  }, true);
  initialize();
  new MutationObserver(initialize).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
})();
